<template>
    <div class="container-fluid" style="height: 100vh; padding: 0;">
        <div class="opening-result d-flex align-items-center justify-content-center">
            <div style="width: 500px" class="text-center">
                <img src="/static/assets/img/opening/boss.png" style="width: 70%;" v-if="bossImg">
                <img src="/static/assets/img/opening/boss2.png" style="width: 70%;" v-if="!bossImg">
                <br>
                <br>
                <div style="border: 3px solid #fff; width: 100%">
                    <div class="hp" :style="{ width: percentage + '%' }">
                        {{ percentage }}%
                    </div>
                </div>
                <div v-if="isDead" class="dead-box">ตายละจ้า</div>
            </div>
        </div>
        <div id="particles-js"></div>
    </div>
</template>

<script>
import firebase from "firebase";
import "particles.js";
export default {
  name: "openingResult",
  data() {
    return {
      count: 0,
      isDead: false,
      bossImg: false
    };
  },
  mounted() {
    this.count = 0;
    firebase
      .database()
      .ref("opening")
      .on("value", snapshot => {
        //   this.count = Object.keys(snapshot.val()).length
        this.count += 0.3;
        this.bossImg  = !this.bossImg
      });

    window.particlesJS.load(
      "particles-js",
      "/static/assets/js/particles/particles.json",
      null
    );
  },
  computed: {
    percentage() {
      return 100 - this.count * 100 / 500;
    }
  },
  watch: {
    percentage(newValue) {
      if (newValue <= 0) {
        // this.isDead = true;
        this.$router.push('openingFinal') 
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
    width: 0px;  /* remove scrollbar space */
    background: transparent;  /* optional: just make scrollbar invisible */
}

#particles-js {
    width: 100%;
    height: 99%;
    position: absolute;
    top: 0;
}

.opening-result {
  background: linear-gradient(#8e1625, #240b36);
  height: 100vh;
}

.hp {
  width: 100px;
  background: #8e1625;
  padding: 8px 10px;
  color: #fff;
  text-align: right;
}

.dead-box {
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/opening/openingResult.vue